import { FEATURE_KEYS } from "../../../constants/plans";

export const MEMBERSHIP_STATUS_STYLES = {
    active:    { color: "success",   icon: "mdi-check-circle",  label: "Ativo" },
    suspended: { color: "warning",   icon: "mdi-pause-circle",  label: "Suspenso" },
    canceled:  { color: "danger",    icon: "mdi-close-circle",  label: "Cancelado" },
    expired:   { color: "secondary", icon: "mdi-clock-alert",   label: "Expirado" }
};

export const MEMBERSHIP_DURATION_LABELS = {
    monthly: (d) => d > 1 ? `${d} meses` : "1 mês",
    yearly:  (d) => d > 1 ? `${d} anos`  : "1 ano",
    days:    (d) => `${d} dias`,
    classes: (d) => `${d} aulas`
};

export const MEMBER_PROFILE_TABS = [
    { id: '1', label: 'Meus Dados', icon: 'mdi-account-outline' },
    { id: '2', label: 'Financeiro', icon: 'mdi-cash-multiple', feature: FEATURE_KEYS.MEMBER_FINANCIAL_TAB, permission: "financial_cashflow" },
    { id: 'attendance', label: 'Frequência', icon: 'mdi-calendar-check' },
    { id: '3', label: 'Matrículas', icon: 'mdi-school-outline' },
    { id: '4', label: 'Planos', icon: 'mdi-file-document-outline', feature: FEATURE_KEYS.MEMBER_MEMBERSHIPS_TAB, permission: "admin_memberships" },
    { id: '5', label: 'Testes', icon: 'mdi-flask-outline' },
    { id: '6', label: 'Avaliações', icon: 'mdi-clipboard-check-outline' },
    { id: '7', label: 'Pontos (XP)', icon: 'mdi-star-circle-outline' },
    { id: '8', label: 'Contatos', icon: 'mdi-phone-message-outline' },
];
